import { downloadGeoJSON } from '../../common/geojson';
import { buildLandCoverGeoJson } from '../utils/landCoverGeoJson';

/**
 * @constant GEOJSON_MODULE
 * @description Module key, used to name the downloaded file.
 * @memberof module:Euscoast
 */
const GEOJSON_MODULE = 'euscoast';

/**
 * @function exportGeoJson
 * @description Writes the urban-growth analysis's vector layers - area, baseline, transects,
 * and the classified land cover and water of each year - to a GeoJSON file.
 * The classification raster itself is not here: it is a live Earth Engine image, and a raster has
 * no place in a vector format. The vectors this analysis derives from it are what the measurements
 * were taken on, and are what carries over to a GIS.
 * @param {Object} params - Same as {@link buildLandCoverGeoJson}.
 * **Called by:
 * @see {ProcessingPage} - EUSCoast's result page, through the GIS export icon.
 * @memberof module:Euscoast
 * @returns {Boolean} False when there was nothing to write.
 */
export const exportGeoJson = (params) => downloadGeoJSON(buildLandCoverGeoJson(params), GEOJSON_MODULE);
